import { useQuery } from '@apollo/client';
import query from '../queries/getPageType.gql.js';
var pagetypeMap = {
  CMS_PAGE: 'CMS',
  CATEGORY: 'Category',
  PRODUCT: 'Product',
  '/cart': 'Cart',
  '/checkout': 'Checkout'
};
export var getPagetype = _ref => {
  var {
    pathname
  } = _ref;
  if (pathname) {
    var queryResult = useQuery(query.resolvePagetypeQuery, {
      fetchPolicy: 'cache-and-network',
      nextFetchPolicy: 'cache-first',
      variables: {
        url: pathname
      }
    });
    var {
      data
    } = queryResult || {};
    var {
      urlResolver
    } = data || {};
    var {
      type
    } = urlResolver || {};
    // use pagetype from graphql, if it doesn't match, check pathname, if it doesn't match, return undefined.
    var pagetype = pagetypeMap[type] || pagetypeMap[pathname];
    return pagetype;
  }
};